import { render, staticRenderFns } from "./ChartDoughnut.vue?vue&type=template&id=1a74b215&scoped=true&"
import script from "./ChartDoughnut.vue?vue&type=script&lang=js&"
export * from "./ChartDoughnut.vue?vue&type=script&lang=js&"
import style0 from "./ChartDoughnut.vue?vue&type=style&index=0&id=1a74b215&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a74b215",
  null
  
)

export default component.exports